/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationid202,
  PutApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationid400,
  PutApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationid401,
  PutApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationid500,
  PutApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidMutationResponse,
  PutApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidPathParams,
} from "../../types/courseRegistrationAssociatedCompanyDocumentApprovalController/PutApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationid.ts";
import { saveAssociatedCompanyDocumentApprovalResponseViewModelSchema } from "../saveAssociatedCompanyDocumentApprovalResponseViewModelSchema.ts";

export const putApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidPathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
  }) as unknown as ToZod<PutApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const putApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationid202Schema =
  z.lazy(
    () => saveAssociatedCompanyDocumentApprovalResponseViewModelSchema,
  ) as unknown as ToZod<PutApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationid202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationid400Schema =
  z.any() as unknown as ToZod<PutApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationid400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationid401Schema =
  z.any() as unknown as ToZod<PutApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationid401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationid500Schema =
  z.any() as unknown as ToZod<PutApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationid500>;

export const putApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidMutationResponseSchema =
  z.lazy(
    () =>
      putApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationid202Schema,
  ) as unknown as ToZod<PutApiV1CourseregistrationAssociatedCompanyDocumentApprovalCourseregistrationidMutationResponse>;
